// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__tbz74","content":"Consent_content__K6rMf","footer":"Consent_footer__2TQ2I"};